import {InformationPanel} from '@eCommerce/frontend-legacy-shared-library-native';
import CAESARS_LAUREL_GRAY from 'assets/OfferCardIcons/caesars_laurel_gray.svg';
import {ReservationState, ReservationStatus} from 'models/Reservations';
import React from 'react';

export interface ReservationsEmptyDisplayPros {
  activeTab?: ReservationState | ReservationStatus;
}

const ReservationsEmptyDisplay: React.FC<ReservationsEmptyDisplayPros> = ({
  activeTab,
}) => {
  const titleText =
    activeTab === ReservationState.FUTURE
      ? 'You have no current reservations... Yet!'
      : activeTab === ReservationState.PAST
        ? 'You have no past reservations.'
        : activeTab === ReservationStatus.CANCELLED
          ? 'You have no cancelled reservations.'
          : '';

  const upperDescriptionText =
    activeTab === ReservationState.FUTURE
      ? "You don't have any upcoming stays in the Empire."
      : activeTab === ReservationState.PAST
        ? " You don't have any past stays in the Empire."
        : activeTab === ReservationStatus.CANCELLED
          ? "You don't have any cancelled stays in the Empire."
          : '';

  const lowerDescriptionText =
    'Explore your exclusive member rates at any of our destinations to play, dine, win and more.';

  return (
    <InformationPanel
      isSVG={true}
      iconName={CAESARS_LAUREL_GRAY}
      iconSize={{height: 79, width: 91}}
      titleText={titleText}
      upperDescriptionText={upperDescriptionText}
      lowerDescriptionText={lowerDescriptionText}
    />
  );
};

export default ReservationsEmptyDisplay;
